export default function arrayMiddleware(store) {
  return next => action => {
    if (Array.isArray(action)) return action.map(a => store.dispatch(a));

    return next(action);
  };
}
